import { useQuery, UseQueryResult } from "react-query";
import { getDiseasesLookup } from "services/diseases";
import { LookupItem } from "api/types";
import useDebouncedValue from "hooks/useDebouncedValue";

/**
 * Search-as-you-type sur le catalogue Diseases (CIM-10, ~14k entrées —
 * impossible de tout charger client-side). Mêmes règles que
 * `useDrugsLookupSearch` : debounce 250 ms, min 2 caractères, cache par
 * requête, keepPreviousData pour éviter le flicker.
 */
export function useDiseasesLookupSearch(
  q: string,
  limit: number = 20
): UseQueryResult<LookupItem[]> {
  const debouncedQ = useDebouncedValue(q, 250);
  const trimmed = debouncedQ.trim();

  return useQuery<any, unknown, LookupItem[]>(
    ["diseases-lookup", trimmed, limit],
    () => getDiseasesLookup({ q: trimmed, limit }),
    {
      enabled: trimmed.length >= 2,
      keepPreviousData: true,
      staleTime: 5 * 60 * 1000,
      select: (result: any) => (result?.ok ? result.data ?? [] : []),
    }
  );
}

export default useDiseasesLookupSearch;
